import { ElementType, FC } from 'react';
import { Circle, Icon, Text, VStack } from '@chakra-ui/react';
import { SelectableCard } from '@netiva/classifieds-ui';

export type NewAccountCardProps = {
  icon: ElementType;
  title: string;
  description: string;
  isSelected?: boolean;
  onClick?: () => void;
};

export const NewAccountCard: FC<NewAccountCardProps> = ({ icon, title, description, isSelected, onClick }) => (
  <SelectableCard isSelected={isSelected} onClick={onClick} height="full">
    <VStack spacing={3} textAlign="center">
      <Circle size={12} bg="white" borderWidth={1} borderColor="neutral.100">
        <Icon as={icon} boxSize={6} />
      </Circle>
      <Text fontWeight="bold" fontSize="lg">
        {title}
      </Text>
      <Text fontSize="sm" color="neutral.500">
        {description}
      </Text>
    </VStack>
  </SelectableCard>
);
